import { ErrorInterface } from '../../interfaces/general.interface';

export interface SetPasswordState {
  error: boolean | ErrorInterface;
  loading: boolean;
  response: boolean | null;
}

export const initialSetPasswordState: SetPasswordState = {
  error: false,
  loading: false,
  response: null,
};
